import { BrowserModule } from '@angular/platform-browser';
import { CUSTOM_ELEMENTS_SCHEMA, NgModule } from '@angular/core';

import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { HomeComponent } from './home/home.component';
import { PreloaderComponent } from './components/preloader/preloader.component';
import { NavBarComponent } from './components/nav-bar/nav-bar.component';
import { FooterComponent } from './components/footer/footer.component';
import { AboutComponent } from './common/about/about.component';
import { ContactComponent } from './common/contact/contact.component';
import { WorkingProgressComponent } from './common/working-progress/working-progress.component';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { HttpClientModule } from '@angular/common/http';
import { ProfessionalServiceService } from './services/professional-service.service';
import { CategoryService } from './services/category.service';
import { CommonModule } from '@angular/common';
import { NgSelectModule } from '@ng-select/ng-select';
import { ProfessionalServicesEditComponent } from './modules/professional-services-edit/professional-services-edit.component';
import { StatesCitiesService } from './services/states-cities.service';
import { NgxSpinnerModule } from 'ngx-spinner';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { SearchService } from './services/search.service';
import { SearchResultComponent } from './search-result/search-result.component';
import { ProfessionalServicesDetailComponent } from './modules/professional-services-detail/professional-services-detail.component';
import { SearchComponent } from './search/search.component';
import { ServiceProvidersEditComponent } from './modules/service-providers-edit/service-providers-edit.component';
import { SignUpComponent } from './modules/sign-up/sign-up.component';
import { LoginComponent } from './modules/login/login.component';
import { UserService } from './services/user.service';
import { ClipboardModule } from '@angular/cdk/clipboard';
import { AuthenticationService } from './services/authentication.service';
import { ToastrModule } from 'ngx-toastr';
import { RegisterAsComponent } from './common/register-as/register-as.component';
import { ManagedServiceEditComponent } from './modules/managed-service-edit/managed-service-edit.component';
import { JwtModule } from '@auth0/angular-jwt';
import { ProfileComponent } from './modules/profile/profile.component';
import { ProfiledServiceService } from './services/profiled-service.service';
import { ViewsService } from './services/views.service';
import { LogoutComponent } from './modules/logout/logout.component';
import { HandleEditComponent } from './modules/handle-edit/handle-edit.component';
import { HandlesService } from './services/handles.service';
import { HandleActionComponent } from './modules/handle-action/handle-action.component';

export function tokenGetter(){
  return localStorage.getItem("currentUser");
}

@NgModule({
  declarations: [
    AppComponent,
    HomeComponent,
    PreloaderComponent,
    NavBarComponent,
    FooterComponent,
    AboutComponent,
    ContactComponent,
    WorkingProgressComponent,
    ProfessionalServicesEditComponent,
    SearchResultComponent,
    ProfessionalServicesDetailComponent,
    SearchComponent,
    ServiceProvidersEditComponent,
    SignUpComponent,
    LoginComponent,
    RegisterAsComponent,
    ManagedServiceEditComponent,
    ProfileComponent,
    LogoutComponent,
    HandleEditComponent,
    HandleActionComponent

   ],
  imports: [
    CommonModule,
    FormsModule,
    BrowserModule,
    AppRoutingModule,
    HttpClientModule,
    ReactiveFormsModule,
    NgSelectModule,
    BrowserAnimationsModule,
    NgxSpinnerModule,
    ClipboardModule,
    JwtModule.forRoot({
      config: {
        tokenGetter: tokenGetter
      }
    }),
    ToastrModule.forRoot({
      timeOut: 3000,
      positionClass: 'toast-top-right',
      preventDuplicates: true,
    }),
  ],

  schemas: [CUSTOM_ELEMENTS_SCHEMA],

  providers: [
    CategoryService,
    ProfessionalServiceService,
    StatesCitiesService,
    SearchService,
    UserService,
    AuthenticationService,
    ProfiledServiceService,
    ViewsService,
    HandlesService
  ],
  bootstrap: [AppComponent]
})
export class AppModule { }
